import { REQUIRED_ANSWER_TYPES } from '../../../routes/sidebar/admin-center/creator/___pages___/elements/ui/questions/ui/creator/constants';

export const FINAL_QUIZ_TYPE = 'Final Quiz';
export const PRACTICE_QUIZ_TYPE = 'Practice quiz';
export const ANSWER_SLOTS = 7;

export const MAX_ANSWER_OPTIONS = ANSWER_SLOTS;

export const MIN_TOTAL_ANSWERS_TO_DISPLAY = 2;
export const MAX_TOTAL_ANSWERS_TO_DISPLAY = 7;

export const QUESTIONS_CSV_COLUMNS = [
    'QuestionID',
    'QuizType',
    'QuestionVariation1',
    'QuestionVariation2',
    'QuestionVariation3',
    'CorrectAnswer1',
    'CorrectAnswer2',
    'CorrectAnswer3',
    'CorrectAnswer4',
    'CorrectAnswer5',
    'CorrectAnswer6',
    'CorrectAnswer7',
    'WrongAnswer1',
    'WrongAnswer2',
    'WrongAnswer3',
    'WrongAnswer4',
    'WrongAnswer5',
    'WrongAnswer6',
    'WrongAnswer7',
    'CorrectFeedback',
    'PartiallyCorrectFeedback',
    'WrongFeedback',
    'QuestionIntroduction',
    'QuestionPrompt',
    'TimeSeconds',
    'TypeOfRequiredAnswer',
    'MinimumCorrectAnswersToSelect',
    'TotalAnswersToSelect',
] as const;

export const QUESTIONS_CSV_HEADER = QUESTIONS_CSV_COLUMNS.join('^');

export const QUESTIONS_CSV_FIELD = {
    questionId: 0,
    quizType: 1,
    variation1: 2,
    variation2: 3,
    variation3: 4,
    correctAnswersStart: 5,
    wrongAnswersStart: 5 + ANSWER_SLOTS,
    correctFeedback: 19,
    partiallyCorrectFeedback: 20,
    wrongFeedback: 21,
    questionIntroduction: 22,
    questionPrompt: 23,
    timeSeconds: 24,
    typeOfRequiredAnswer: 25,
    minimumCorrectAnswersToSelect: 26,
    totalAnswersToSelect: 27,
} as const;

export const EXPECTED_COLUMN_COUNT = QUESTIONS_CSV_COLUMNS.length;

export const QUESTIONS_CSV_IMPORT_STATUS_SUCCESS = 'success';
export const QUESTIONS_CSV_IMPORT_STATUS_PARTIAL = 'partial';
export const QUESTIONS_CSV_IMPORT_STATUS_FAILED = 'failed';

export const QUESTIONS_CSV_IMPORT_STATUSES = [
    QUESTIONS_CSV_IMPORT_STATUS_SUCCESS,
    QUESTIONS_CSV_IMPORT_STATUS_PARTIAL,
    QUESTIONS_CSV_IMPORT_STATUS_FAILED,
] as const;

export const ACCENT_INSENSITIVE_COMPARE = { sensitivity: 'accent' } as const;
export const DEFAULT_MINIMUM_CORRECT_ANSWERS = 1;
export const DEFAULT_TOTAL_ANSWERS_TO_SELECT = 4;
export const DECIMAL_RADIX = 10;

export const ACCEPTED_QUIZ_TYPES = [FINAL_QUIZ_TYPE, PRACTICE_QUIZ_TYPE] as const;
export const ACCEPTED_REQUIRED_ANSWER_TYPES = [
    REQUIRED_ANSWER_TYPES.RANDOM,
    REQUIRED_ANSWER_TYPES.CORRECT,
    REQUIRED_ANSWER_TYPES.WRONG,
] as const;

export const INCORRECT = 'incorrect';
